<!-- 圆形确认框 -->
<template>
  <van-dialog
    v-model="showDialog"
    :showConfirmButton="false"
    :close-on-click-overlay="isClickClose"
    @close="changeClose"
    :class="direction ? 'directionDegrees' : ''"
  >
    <div class="dialogContent">
      <div class="TitleBox">
        <div class="deleteTitle">剪切板</div>
        <img src="@/assets/icons/x.png" alt="" @click="closeDialog" />
      </div>
      <van-field
        v-model="inputValue"
        placeholder="请输入内容"
        type="textarea"
        class="inputBox"
      />
      <button class="button deleteAffirm" @click="affirm">立即粘贴</button>
    </div>
  </van-dialog>
</template>
          <script>
export default {
  name: "SecondConfirm",
  components: {},
  model: {
    prop: "showDialog",
    event: "change",
  },
  props: {
    // 弹框的显示隐藏
    showDialog: {
      type: Boolean,
      default: false,
    },
    // 是否点击遮罩隐藏弹窗
    isClickClose: {
      type: Boolean,
      default: true,
    },
    // 标题
    title: {
      type: String,
      default: "提示",
    },
    // 标题
    content: {
      type: String,
      default: "",
    },
    // 是否选择90度
    direction: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      inputValue: "",
    };
  },
  methods: {
    affirm() {
      this.$emit("affirm", this.inputValue);
    },
    closeDialog() {
      this.$emit("update:showDialog", false);
    },
    changeClose() {
      this.inputValue = "";
      this.$emit("update:showDialog", false);
    },
  },
};
</script>
          <style lang="less" scoped>
.button {
  border: none;
  background: none;
}
.dialogContent {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  .TitleBox {
    display: flex;
    justify-content: space-between;
    img {
      width: 20px;
      height: 20px;
    }
    .deleteTitle {
      font-size: 24px;
      font-weight: 700;
      color: #121212;
    }
  }
}

.inputBox {
  border-radius: 10px;
  border: 1px solid hsla(0, 0%, 60%, 0.2);
  margin: 20px 0;
  /deep/.van-field__control {
    color: #666;
    font-size: 20px;
    height: 80px;
    line-height: 20px;
  }
}
.deleteAffirm {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #886df3;
  border-radius: 20px;
  font-size: 18px;
  color: #fff;
  font-weight: 700;
}
.directionDegrees {
  transform: rotate(90deg) translate3d(-50%, -50%, 0);
  transform-origin: 0px 0px;
}
</style>
          